import { render, staticRenderFns } from "./NftCollectionImageRender.vue?vue&type=template&id=74ab9894&scoped=true"
import script from "./NftCollectionImageRender.vue?vue&type=script&lang=ts"
export * from "./NftCollectionImageRender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ab9894",
  null
  
)

export default component.exports